import { BrowserRouter, Routes, Route, Navigate, Outlet, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { PreferencesProvider } from "@/context/PreferencesContext";
import { Navbar, Footer } from "@/components/Layout";
import SiteGate from "@/components/SiteGate";
import PreferencesModal from "@/components/PreferencesModal";
import Home from "@/pages/Home";
import { LoginPage, RegisterPage } from "@/pages/Auth";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import FAQ from "@/pages/FAQ";
import Catalog from "@/pages/Catalog";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import { PaymentSuccess } from "@/pages/PaymentSuccess";
import Orders from "@/pages/Orders";
import ArtistDashboard from "@/pages/ArtistDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import { ArtistsList, ArtistDetail } from "@/pages/Artists";
import useHeartbeat from "@/hooks/useHeartbeat";
import "@/App.css";

function ProtectedRoute({ roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="p-20 text-center uppercase tracking-widest text-white/50">Chargement...</div>;
  if (!user || !user.id) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return <Outlet />;
}

function Shell() {
  useHeartbeat();
  return (
    <>
      <Navbar />
      <main className="min-h-[calc(100vh-64px)]">
        <Outlet />
      </main>
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <SiteGate>
        <PreferencesProvider>
          <PreferencesModal />
          <AuthProvider>
            <CartProvider>
              <Toaster position="top-center" richColors theme="dark" />
            <Routes>
              <Route element={<Shell />}>
                <Route path="/" element={<Home />} />
                <Route path="/catalogue" element={<Catalog />} />
                <Route path="/produits/:id" element={<ProductDetail />} />
                <Route path="/panier" element={<Cart />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/pilotes" element={<ArtistsList />} />
                <Route path="/pilotes/:id" element={<ArtistDetail />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/mot-de-passe-oublie" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/politiques" element={<FAQ />} />
                <Route element={<ProtectedRoute />}>
                  <Route path="/commandes" element={<Orders />} />
                </Route>
                <Route element={<ProtectedRoute roles={["artist", "admin"]} />}>
                  <Route path="/pilote/dashboard" element={<ArtistDashboard />} />
                </Route>
                <Route element={<ProtectedRoute roles={["admin"]} />}>
                  <Route path="/admin" element={<AdminDashboard />} />
                </Route>
              </Route>
              </Routes>
            </CartProvider>
          </AuthProvider>
        </PreferencesProvider>
      </SiteGate>
    </BrowserRouter>
  );
}
